var map = {
	"./SDK-spec.js": 3,
	"./core/Cache-spec.js": 10,
	"./core/Observable-spec.js": 11,
	"./core/Queue-spec.js": 12,
	"./core/Utils-spec.js": 13,
	"./http/ApiResponse-spec.js": 14,
	"./http/Client-spec.js": 15,
	"./platform/Platform-spec.js": 16,
	"./subscription/CachedSubscription-spec.js": 17,
	"./subscription/Subscription-spec.js": 18
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2;



/*****************
 ** WEBPACK FOOTER
 ** ./src .+\-spec\.js$
 ** module id = 2
 ** module chunks = 0
 **/